import {UserRole} from "../../../authentication/authenticated-user";
import {isAnalysisCloseable, MeasurementType} from "../../../measurement-models";
import {MeasurementStatus} from "../../found-measurement";

export interface CloseAnalysisButtonParams {
  readonly role: UserRole;
  readonly type: MeasurementType;
  readonly status: MeasurementStatus;
  readonly feature569Released: boolean;
}

export function shouldShowCloseAnalysisButton(
  {role, type, status, feature569Released}: CloseAnalysisButtonParams
): boolean {
  return role === "DATA_OFFICER"
    && isCloseable(type, feature569Released)
    && status === "READY_FOR_POST_ANALYSIS";
}

function isCloseable(type: MeasurementType, feature569Released: boolean): boolean {
  if (type === "SLEEP") {
    return feature569Released;
  }

  return isAnalysisCloseable(type);
}
